export interface ItemCompra {
  tipo_veiculo: string;
  quantidade: number;
  preco_vistoriadora: number;
  preco_owner: number;
  subtotal: number;
}

export const VALOR_MINIMO_CREDITO = 5;

export function precoCreditoValido(eixo1: number, eixo2: number): boolean {
  return eixo1 + eixo2 >= VALOR_MINIMO_CREDITO;
}

/**
 * Monta os itens de uma compra de crédito com o breakdown Eixo 1 (preço que a
 * Vistoriadora cobra do Parceiro, por tipo de veículo) + Eixo 2 (fee fixo que o
 * Owner cobra dessa Vistoriadora, sempre flat — sem variação por tipo).
 * Só inclui tipos com quantidade > 0.
 */
export function montarItensCompra(
  quantidades: Record<string, number>,
  precosVistoriadora: Record<string, number>,
  eixo2: number,
): ItemCompra[] {
  return Object.entries(quantidades)
    .filter(([, qtd]) => qtd > 0)
    .map(([tipo, qtd]) => {
      const precoVist = precosVistoriadora[tipo] || 0;
      return {
        tipo_veiculo: tipo,
        quantidade: qtd,
        preco_vistoriadora: precoVist,
        preco_owner: eixo2,
        subtotal: (precoVist + eixo2) * qtd,
      };
    });
}

export function totalBase(itens: ItemCompra[]): number {
  return itens.reduce((acc, item) => acc + item.subtotal, 0);
}

// Self-check: node --import tsx client/src/lib/split-pricing.ts
if (typeof process !== "undefined" && process.argv[1]?.endsWith("split-pricing.ts")) {
  // Exemplo do Owner: Vistoriadora cobra R$15/laudo, Owner cobra R$5/laudo → R$20 por laudo
  const itens = montarItensCompra(
    { auto_leve: 2, moto: 0 },
    { auto_leve: 15, moto: 10 },
    5,
  );
  console.assert(itens.length === 1, `esperado 1 item, recebido ${itens.length}`);
  console.assert(itens[0].preco_vistoriadora === 15, `Eixo1 esperado 15, recebido ${itens[0].preco_vistoriadora}`);
  console.assert(itens[0].preco_owner === 5, `Eixo2 esperado 5, recebido ${itens[0].preco_owner}`);
  console.assert(itens[0].subtotal === 40, `subtotal esperado 40 (2×20), recebido ${itens[0].subtotal}`);
  console.assert(totalBase(itens) === 40, `total esperado 40, recebido ${totalBase(itens)}`);

  // Eixo 2 ausente (Vistoriadora sem fee do Owner configurado) → Owner recebe 0, sem bloquear
  const semEixo2 = montarItensCompra({ moto: 1 }, { moto: 12 }, 0);
  console.assert(semEixo2[0].preco_owner === 0, `Eixo2 ausente esperado 0, recebido ${semEixo2[0].preco_owner}`);
  console.assert(semEixo2[0].subtotal === 12, `subtotal esperado 12, recebido ${semEixo2[0].subtotal}`);

  console.log("split-pricing.ts self-check OK");
}
